module.exports = __webpack_public_path__ + "static/media/codepen.7d2fefb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/logs/buffalo/codepen.png
// module id = 723
// module chunks = 0